import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach token (parent/teacher token for their paths, admin token elsewhere)
api.interceptors.request.use((config) => {
  const url = config.url || "";
  const isParent = url.startsWith("/parent/") || url.startsWith("parent/");
  const isTeacher = url.startsWith("/teacher/") || url.startsWith("teacher/");
  let token;
  if (isTeacher) token = localStorage.getItem("elan_teacher_token");
  else if (isParent) token = localStorage.getItem("elan_parent_token");
  else token = localStorage.getItem("elan_admin_token");
  if (token && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      const url = err.config?.url || "";
      if (url.startsWith("/teacher/") || url.startsWith("teacher/")) {
        localStorage.removeItem("elan_teacher_token");
        localStorage.removeItem("elan_teacher_email");
      } else if (url.startsWith("/parent/") || url.startsWith("parent/")) {
        localStorage.removeItem("elan_parent_token");
        localStorage.removeItem("elan_parent_email");
      } else {
        localStorage.removeItem("elan_admin_token");
        localStorage.removeItem("elan_admin_email");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
